// Module
var code = "<% for (var i = 0; i < levels.length; i++) { %>\n<span class=\"quality\" data-quality-select=\"<%= levels[i].id %>\"\n  ><%= levels[i].label %></span\n>\n<% }; %>\n<span class=\"quality\" data-quality-select=\"-1\"><%= quality_auto %></span>\n";
// Exports
export default code;